import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { IonSlides, Platform } from '@ionic/angular';
import { CloseOverlayService } from 'src/app/shared/_services/closeOverlay.service';
import { DashboardStore } from 'src/app/shared/_services/store';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.page.html',
  styleUrls: ['./reports.page.scss'],
  providers: [DatePipe]
})
export class ReportsPage implements OnInit {
  today = Date.now();
  selectedSlide: any;
  subscription: any;
  todayDate: string;
  pickerDate = this.dashboardStore.getPickerDate();
  segment = 0;
  sliderOptions = {
    initialSlide: 0,
    slidesPreview: 1,
    speed: 400
  };

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private platform: Platform,
    private dashboardStore: DashboardStore,
    private closeOverlayService: CloseOverlayService
  ) { }

  segmentChanged(ev: any) {
    this.selectedSlide.slideTo(this.segment);
  }

  async slidesChange(slides: IonSlides) {
    this.selectedSlide = slides;
    slides.getActiveIndex().then(selectedIndex => {
      this.segment = selectedIndex;
    });
  }

  ionViewWillEnter() {
    document.title = 'Reports | Bank3D';
    const dateText = document.getElementById('general-date-text');
    const dateTextInner: HTMLElement = dateText.shadowRoot.querySelector('.datetime-text');
    dateTextInner.innerText = 'Today';

    const dateText2 = document.getElementById('cashier-date-text');
    const dateTextInner2: HTMLElement = dateText2.shadowRoot.querySelector('.datetime-text');
    dateTextInner2.innerText = 'Today';
  }

  goBack() {
    this.router.navigateByUrl('/dashboard');
  }

  ionViewDidEnter() {
    this.subscription = this.platform.backButton.subscribeWithPriority(99999, () => {
      this.goBack();
    });
  }

  ionViewDidLeave() {
    this.subscription.unsubscribe();
  }

  ngOnInit() {
    this.pickerDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    this.todayDate = this.datePipe.transform(this.today, 'yyyy-MM-dd');
    window.onpopstate = (() => {
      this.closeOverlayService.trigger();
    });
  }

}
